// extracted by mini-css-extract-plugin
module.exports = {"item":"List_item__3ljiE"};